import React from 'react'

interface valuesType {
    linebreak: React.ReactNode,
    b: React.ReactNode,
    sub: React.ReactNode,
    sup: React.ReactNode
}


const values:valuesType = {
    linebreak: <br />,
    b: (...chunks:any) => <strong>{chunks}</strong>,
    sub: (...chunks:any) => <sub>{chunks}</sub>,
    sup: (...chunks:any) => <sup>{chunks}</sup>
}

export default values;
